import { InputFieldType } from "src/types/checkout";
import { ClipboardEvent, KeyboardEvent } from "react";
import { INSURED_PERSON_FORM_FIELDS } from "src/constants/applicationForm";

export const isGenderFormField = (fieldName: (string | number)[] = []) =>
  fieldName[fieldName.length - 1] === INSURED_PERSON_FORM_FIELDS.GENDER;

export const convertObjectToInputFields = (
  obj: Record<string, any>
): InputFieldType[] =>
  Object.keys(obj)?.map((key) => ({ inputCode: key, value: obj[key] }));

export const handleOnKeyPressNumberEvent = (
  event: KeyboardEvent<HTMLInputElement>
) => {
  ["e", "E", "+", "-"].includes(event.key) && event.preventDefault();
};

export const handleOnPasteNumberEvent = (
  event: ClipboardEvent<HTMLInputElement>
) => {
  event.preventDefault();

  document.execCommand(
    "insertText",
    false,
    event.clipboardData?.getData("text").replace(/\D/g, "")
  );
};
